import {Directive, Injector, OnDestroy, OnInit} from "@angular/core";
import {Subject} from "rxjs";
import {DateHelper} from "../../_helpers/date.helper";
import {ActivatedRoute, Router} from "@angular/router";
import {JwtHelperService} from "@auth0/angular-jwt";
import {MatSnackBar} from "@angular/material/snack-bar";
import {JWT_TOKEN_KEY} from "../../_constants/common.constant";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {InformationDialog} from "../dialog/information.dialog";
import {UiHelper} from "../../_helpers/ui.helper";
import {ProfileMessage} from "../../_services/profile.message";
import {AuthService} from "../../pages/login/services/auth.service";
import {co} from "@fullcalendar/core/internal-common";

@Directive()
export abstract class BaseComponentDirective implements OnInit, OnDestroy {
    protected ngUnsubscribe = new Subject();
    public date = DateHelper;
    public ui = UiHelper;
    public router: Router;
    public activatedRoute: ActivatedRoute;
    public jwtService: JwtHelperService;
    public snackBar: MatSnackBar;
    public isSignedIn: boolean;
    public userProfile: any = {};
    public dialog: MatDialog;
    public profileMsg: ProfileMessage;
    public authService: AuthService;

    protected constructor(injector: Injector) {
        this.router = injector.get(Router);
        this.activatedRoute = injector.get(ActivatedRoute);
        this.jwtService = injector.get(JwtHelperService);
        this.snackBar = injector.get(MatSnackBar);
        this.dialog = injector.get(MatDialog);
        this.profileMsg = injector.get(ProfileMessage);
        this.authService = injector.get(AuthService);
    }

    ngOnInit(): void {
        this.isSignedIn = !this.jwtService.isTokenExpired();
        this.profileMsg.currentMessage.subscribe(r => {
            if(r) {
                this.userProfile = r;
            }

        })

        if (!this.isSignedIn) {
            localStorage.removeItem(JWT_TOKEN_KEY);
        }
    }

    markFormGroupAsTouched(formGroup: FormGroup): void {
        Object.values(formGroup.controls).forEach(control => {
            if (control instanceof FormGroup) {
                this.markFormGroupAsTouched(control); // If it's another form group, recursively call the function
            } else {
                control.markAsTouched();
                control.markAsDirty();
                // Mark the individual form control as touched
            }
        });
    }

    check(form: FormGroup): any {
        let valid: { controlName: string; value: any; valid: boolean; x: any } = null;
        let disableMarker: string = null;
        Object.keys(form.controls).forEach(controlName => {
            const control = form.get(controlName);
            if (control.status === 'DISABLED') {
                form.get(controlName).enable();
                disableMarker = controlName;
            }
            form.get(controlName).enable();
            if (control.status === 'INVALID' && !valid) {
                valid = {
                    controlName,
                    value: control.value,
                    valid: control.valid,
                    x: control.errors
                };

                console.log(valid);
            }
            if (disableMarker) {
                form.get(controlName).disable();
                disableMarker = null;
            }
        });
        return valid;
    }

    maskingColumn(label: string, value: any, items: any[], val: any): any {
        // tslint:disable-next-line:triple-equals
        const f = items.find(i => i[value] == val);
        return (f) ? f[label] : '-';
    }

    showAlert(title: string, message: string, subMessage: string) {
        this.dialog.open(InformationDialog, {
            data: {
                message: message,
                subMessage: subMessage,
                title: title
            }
        })
    }

    showAlertDark(title: string, message: string, subMessage: string) {
        this.dialog.open(InformationDialog, {
            data: {
                message: message,
                subMessage: subMessage,
                title: title,
                theme: 'dark'
            }
        })
    }

    showSnackbarDark(title: string, message: string, subMessage: string) {
        this.snackBar.open(message, '', {duration: 3000, verticalPosition: 'top', horizontalPosition: 'center'})
    }

    ngOnDestroy(): void {
        this.ngUnsubscribe.next(null);
        this.ngUnsubscribe.complete();
    }
}
